import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:formID?',
      name: 'quote',
      component: () =>
        import(/* webpackChunkName: "quote" */ './views/Quote.vue'),
      props: {
        formID: false,
      },
    },
    {
      path: '/request/:offerID?',
      name: 'request',
      component: () =>
        import(
          /* webpackChunkName: "RequestOffer" */ './views/RequestOffer.vue'
        ),
      props: {
        formID: false,
      },
    },
  ],
});
